import React = require("react");
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./container/App";
import { store } from './stores/AppStore';

createRoot(document.getElementById("main")).render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);